<template>
  <bm-dialog :label="dialogTitle" :cancelable="false" @cancel="cancel">
    <v-container pa-0 fluid>
      <v-row no-gutters>
        <v-col cols="12">
          <bm-barcode-input
            ref="barcodeTextElement"
            :barcode-types="barcodeTypes"
            :label="$m.racking_enter_label_no_label"
            :rules="[$ruleSet.required()]"
            :disable-camera-input="disableCameraInput"
            @input-complete="inputComplete"
          />
        </v-col>
      </v-row>
      <v-row class="pl-1 py-0">
        <v-col cols="12" class="py-0">
          <slot name="additional-information" />
        </v-col>
      </v-row>
    </v-container>
    <template #controls>
      <slot name="controls">
        <bm-btn
          block
          button-type="secondary"
          :x-large="xLarge"
          :t="$m.keys.back"
          @click="cancel"
        />
      </slot>
    </template>
  </bm-dialog>
</template>
<script setup lang="ts">
import BmBtn from "@/components/controls/input/BmBtn.vue";
import BmDialog from "@/components/dialogs/BmDialog.vue";
import BmBarcodeInput from "@/components/controls/device/BmBarcodeInput.vue";
import { watch } from "vue";
import { makeRef } from "@/components/composables/reactivityTypes";
import { EnumBrewmanBarcodeType } from "@/app/services/generated/enums/enumBrewmanBarcodeType.generated";
import appStore from "@/store/modules/appStore";
import messages from "@/plugins/i18n";

interface ScanContainerDialogProps {
  xLarge?: boolean;
  barcodeTypes?: EnumBrewmanBarcodeType[];
  dialogTitle?: string;
  disableCameraInput?: boolean;
}

export interface ScanContainerDialogEvents {
  (e: "input-complete", v: string): void;
  (e: "cancel"): void;
}

withDefaults(defineProps<ScanContainerDialogProps>(), {
  xLarge: false,
  barcodeTypes: () => [EnumBrewmanBarcodeType.tracking],
  dialogTitle: messages.racking_scan_container,
  disableCameraInput: false,
});
const emit = defineEmits<ScanContainerDialogEvents>();

const cancel = () => emit("cancel");

const barcodeTextElement = makeRef(null);

const inputComplete = (scannedValue: string) => {
  if (scannedValue.length) {
    emit("input-complete", scannedValue);
  }
};

const getInput: () => HTMLInputElement | undefined = () => {
  const inputElements = (
    ((barcodeTextElement.value as any)?.$refs.barcodeScannerField as any)
      ?.$el as HTMLElement | undefined
  )?.getElementsByTagName("input");

  return inputElements?.length ? inputElements[0] : undefined;
};

watch(
  () => appStore.state.loading,
  async () => {
    getInput()?.focus();
  }
);
</script>
